import PropTypes from 'prop-types';
import {createContext, useState} from 'react';

const FilterContext = createContext();

const FilterProvider = ({children}) => {
  const savedFilters = JSON.parse(localStorage.getItem('filters'));

  const [filters, setFilters] = useState(
    savedFilters || {
      jewelryType: '',
      productType: '',
      minPrice: '',
      maxPrice: '',
    },
  );

  // Clear filters and remove from localStorage
  const resetFilters = () => {
    const defaultFilters = {
      jewelryType: '',
      productType: '',
      minPrice: '',
      maxPrice: '',
    };

    setFilters(defaultFilters);
  };

  return (
    <FilterContext.Provider value={{filters, setFilters, resetFilters}}>
      {children}
    </FilterContext.Provider>
  );
};

FilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {FilterProvider, FilterContext};
